import React, { useEffect } from "react";
import { userService } from "../../services";

export const PrivateRoute = ({ component: Component, isAllowed, ...rest }) => {
  useEffect(() => {
    userService.checkProfile();
  }, []);

  return <Component {...rest} />;
};